import { Mail, CalendarCheck2 } from "lucide-react";
import { IGNITE_CONSULT_URL } from "@/lib/leads";
import PaperformEmbed from "@/components/PaperformEmbed";

export default function Contact() {
    return (
        <div data-testid="page-contact">
            <section className="section pt-16 md:pt-24" data-testid="contact-hero">
                <div className="container-x">
                    <div className="max-w-3xl space-y-6">
                        <p className="eyebrow">Contact</p>
                        <h1 className="h1">
                            Start your free benefits assessment{" "}
                            <span className="text-navy">in about two minutes.</span>
                        </h1>
                        <p className="lead">
                            Share a few details about your team below and we'll follow
                            up with an intro to Ignite Health along with a scheduling
                            link. Prefer to book straight away? Grab a time on the
                            calendar to the right.
                        </p>
                    </div>
                </div>
            </section>

            <section className="section border-t border-border" data-testid="contact-grid">
                <div className="container-x grid lg:grid-cols-12 gap-12">
                    {/* Embedded Paperform (primary intake) */}
                    <div className="lg:col-span-8">
                        <div
                            className="border border-border p-4 md:p-6 bg-background"
                            data-testid="contact-paperform-block"
                        >
                            <p className="eyebrow mb-3">Get Your Free Benefits Assessment</p>
                            <h2 className="h3 mb-6">
                                Fill this out — we usually respond within one
                                business day.
                            </h2>
                            <PaperformEmbed formId="ywbjco9t" />
                        </div>
                    </div>

                    {/* Side rail */}
                    <div className="lg:col-span-4 space-y-6">
                        <div
                            className="border border-border p-7 bg-surface"
                            data-testid="contact-ignite-block"
                        >
                            <CalendarCheck2 className="h-5 w-5 text-navy mb-4" strokeWidth={1.5} />
                            <p className="eyebrow mb-2">If you're ready</p>
                            <h3 className="font-heading text-xl mb-3">
                                Book a Consult with Ignite Health
                            </h3>
                            <p className="text-sm text-ink-soft mb-5">
                                Skip ahead and book a direct consult with our
                                featured benefits partner.
                            </p>
                            <a
                                href={IGNITE_CONSULT_URL}
                                target="_blank"
                                rel="noreferrer"
                                data-testid="contact-ignite-block-cta"
                                className="inline-flex items-center gap-2 text-sm font-medium text-foreground hover:text-brand border-b border-foreground hover:border-brand pb-1"
                            >
                                Book a consult →
                            </a>
                        </div>

                        <div className="border border-border p-7 bg-surface" data-testid="contact-best-for">
                            <p className="eyebrow mb-3">Who this is best for</p>
                            <p className="body text-sm">
                                Small and midsize businesses looking to improve
                                hiring, retention, or employee benefits. If you're
                                not sure whether it's a fit, send a note — we'll be
                                upfront about what we can do.
                            </p>
                        </div>

                        <div className="border border-border p-7" data-testid="contact-direct">
                            <p className="eyebrow mb-3">Direct</p>
                            <a
                                href="mailto:info@thehrconnect.co"
                                className="inline-flex items-center gap-2 text-foreground hover:text-brand"
                                data-testid="contact-direct-email"
                            >
                                <Mail className="h-4 w-4" strokeWidth={1.5} />
                                info@thehrconnect.co
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
